import React, { useState } from 'react';
import clsx from 'clsx';
import IconPlus from '../utils/icon/icon-plus.svg';
import IconMinus from '../utils/icon/icon-minus.svg';

const ProductAccordions = (props) => {
  const blocks = props.blocks?.filter((block) => block.type === 'accordion');
  if (!blocks || !blocks.length) return null;

  const accordionList = blocks.map((block, i) => {
    if (i > 2) return null;

    const [isOpen, setIsOpen] = useState(block.openByDefault || false);

    const Accordion = () => (
      <div className="accordion relative rounded-md bg-brand-light-beige px-4">
        <div id={`accordion-header-${i}`}>
          <h3 className="body-1">
            <button
              aria-expanded={isOpen}
              aria-controls={`accordion-content-${i}`}
              className="flex w-full justify-between py-6 [&>svg]:block [&>svg]:size-3"
              onClick={() => setIsOpen(!isOpen)}
            >
              <span
                className="rte"
                dangerouslySetInnerHTML={{ __html: block.title }}
              ></span>
              {isOpen ? <IconMinus aria-hidden="true" /> : <IconPlus aria-hidden="true" />}
            </button>
          </h3>
        </div>
        <div
          id={`accordion-content-${i}`}
          className={clsx('body-2 [&>p]:body-2 rte pb-5', { hidden: !isOpen })}
          aria-labelledby={`accordion-header-${i}`}
          role="region"
          dangerouslySetInnerHTML={{ __html: block.description }}
        ></div>
      </div>
    );

    return <Accordion key={i}></Accordion>;
  });

  return <div className="flex flex-col gap-3">{accordionList}</div>;
};

export default ProductAccordions;
